module.exports = __webpack_public_path__ + "img/detail_bottom.a9eb98fb.png";